import css from './DeleteButton.module.css';
import BasicButton, { BasicButtonProps } from '../BasicButton/BasicButton';
import { BinIcon } from '@shared/Icons/BinIcon';
import React from 'react';

interface DeleteButtonProps extends Omit<BasicButtonProps, 'children'> {
    iconWidth?: number;
    iconHeight?: number;
    iconFill?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
    className = css.deleteButton,
    iconWidth = 17,
    iconHeight = 19,
    iconFill = 'currentColor',
    ...rest
}) => {
    return (
        <BasicButton className={className} {...rest}>
            <BinIcon width={iconWidth} height={iconHeight} fill={iconFill} />
        </BasicButton>
    );
};

export default DeleteButton;
